module.exports = __webpack_public_path__ + "static/img/13.e10e05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/13.png
// module id = TvUY
// module chunks = 0